import { useEffect } from "react";

/**
 * Lightweight document.title + meta-description manager.
 * For an SPA without SSR, this is the realistic best-effort:
 * Googlebot runs JS so it picks up the updated values; social-media crawlers
 * may not, so we keep canonical fallback values in /public/index.html.
 */
export default function useDocumentMeta({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = `${title} · BrewFinder`;
    let metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") || "";
    if (description) {
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", description);
    }
    // og:title and og:description for social crawlers (best-effort)
    const setOg = (prop, val) => {
      if (!val) return;
      let m = document.querySelector(`meta[property="${prop}"]`);
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("property", prop);
        document.head.appendChild(m);
      }
      m.setAttribute("content", val);
    };
    setOg("og:title", title ? `${title} · BrewFinder` : "BrewFinder");
    setOg("og:description", description || "");
    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc) metaDesc.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
